import { Injectable } from '@angular/core';
export interface SelectedOrg {
  _id: string;
  name: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SelectedOrgService {

  private readonly STORAGE_KEY = 'lastSelectedOrg';
  private lastSelectedOrg: SelectedOrg | null = null;

  constructor() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored && stored !== 'undefined') {
      try {
        this.lastSelectedOrg = JSON.parse(stored);
      } catch (e) {
        console.error('Error parsing lastSelectedOrg from localStorage', e);
        this.lastSelectedOrg = null;
      }
    }
  }

  setSelectedOrg(org: SelectedOrg | null) {
    this.lastSelectedOrg = org;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(org));
  }

  getSelectedOrg(): SelectedOrg | null {
    return this.lastSelectedOrg;
  }

  clearSelectedOrg() {
    this.lastSelectedOrg = null;
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
